import { render, staticRenderFns } from "./mygroupwork.vue?vue&type=template&id=532dcd86&scoped=true"
import script from "./mygroupwork.vue?vue&type=script&lang=js"
export * from "./mygroupwork.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532dcd86",
  null
  
)

export default component.exports